import { getProfile, setProfile } from '@/utils/tokenStore';
import { createI18n } from 'vue-i18n'
import messages from './messages.json'

// 지원 locale 화이트리스트 (런타임 검증용)
const SUPPORTED_LOCALES = ['ko', 'en', 'zh']
const DEFAULT_LOCALE = 'ko'

// messages 객체 구조 변환
const transformedMessages = {
  ko: {},
  en: {},
  zh: {}
};

// messages의 각 키에 대해 언어별로 재구성
Object.keys(messages).forEach(key => {
  transformedMessages.ko[key] = messages[key].ko;
  transformedMessages.en[key] = messages[key].en;
  transformedMessages.zh[key] = messages[key].zh;
});

// localStorage에서 저장된 locale 복구 (런타임 화이트리스트 검증)
function getStoredLocale() {
  try {
    const stored = getProfile('locale')
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
      return stored
    }
  } catch (e) {
    // localStorage 접근 실패 시 기본값 사용 (SSR/private mode 등)
  }
  return DEFAULT_LOCALE
}

const i18n = createI18n({
  legacy: true, // legacy 모드로 변경
  globalInjection: true, // 전역 주입 활성화
  locale: getStoredLocale(), // 부트스트랩 시 localStorage에서 복구
  fallbackLocale: DEFAULT_LOCALE,
  messages: transformedMessages,
  missing: (locale, key) => {
    console.warn(`Translation key "${key}" not found for locale "${locale}"`)
    return key
  }
})

export default i18n

// 언어 변경 함수 (i18n + localStorage 동시 동기화)
export const setLanguage = (lang) => {
  if (!SUPPORTED_LOCALES.includes(lang)) {
    console.warn(`Unsupported locale: "${lang}". Allowed: ${SUPPORTED_LOCALES.join(', ')}`)
    return
  }
  i18n.global.locale = lang
  try {
    setProfile('locale', lang)
  } catch (e) {
    // localStorage 쓰기 실패 시 메모리 상태만 업데이트
  }
}

// 현재 언어 가져오기
export const getCurrentLanguage = () => i18n.global.locale